import React from 'react';
export function AuthorStory() {
  return <section className="py-20 md:py-28 px-4 bg-dark-secondary" data-id="element-1">
      <div className="max-w-content mx-auto" data-id="element-2">
        <div className="flex flex-col md:flex-row gap-12 items-start" data-id="element-3">
          {/* LEFT: Author Info */}
          <div className="w-full md:w-1/3 flex flex-col items-center md:items-start shrink-0" data-id="element-4">
            <div className="relative w-40 h-40 mb-6" data-id="element-5">
              {/* Gold border ring */}
              <div className="absolute inset-0 rounded-full border-2 border-gold/40 p-1" data-id="element-6">
                <div className="w-full h-full rounded-full bg-dark-card flex items-center justify-center overflow-hidden relative" data-id="element-7">
                  {/* Warm lighting effect */}
                  <div className="absolute inset-0 bg-gradient-to-tr from-gold/20 to-transparent" data-id="element-8"></div>
                  <span className="font-serif font-bold text-5xl text-gold" data-id="element-9">
                    RG
                  </span>
                </div>
              </div>
            </div>

            <h3 className="font-serif font-bold text-2xl text-cream mb-1 text-center md:text-left w-full" data-id="element-10">
              Roderic Guillen
            </h3>
            <p className="font-sans text-[13px] text-gold uppercase tracking-wider mb-2 text-center md:text-left w-full" data-id="element-11">
              Fundador de GoDeskCore
            </p>
            <p className="font-sans text-[13px] text-gray-warm text-center md:text-left w-full" data-id="element-12">
              Sobreviviente de 6 bypass coronarios
            </p>
          </div>

          {/* RIGHT: Story */}
          <div className="w-full md:w-2/3" data-id="element-13">
            <span className="inline-block font-mono text-[11px] text-gold uppercase tracking-[0.2em] mb-4" data-id="element-14">
              POR QUÉ ESCRIBÍ ESTE LIBRO
            </span>

            <div className="space-y-6 font-sans text-cream text-[16px] md:text-[17px] leading-relaxed mb-10" data-id="element-15">
              <p data-id="element-16">
                Hay preguntas que nacen en una cama de hospital. En mi caso
                nacieron después de despertar de una cirugía de seis bypass, con
                el pecho cosido, y una inquietud que nadie me podía responder:
                ¿qué había pasado realmente dentro de mi cuerpo? ¿Por qué?
              </p>
              <p data-id="element-17">
                Lo que encontré en ese camino me sorprendió: información
                respaldada por ciencia, disponible pero dispersa. Médicos que no
                tienen tiempo para explicarla. Y millones de personas que toman
                decisiones sin ella — no porque no quieran, sino porque nadie se
                la explica con claridad.
              </p>
              <p data-id="element-18">
                Por eso escribí este libro. No porque lo sé todo. Lo escribí
                porque lo merece mejor.
              </p>
              <p className="font-serif italic text-gold" data-id="element-19">— Roderic Guillen</p>
            </div>

            {/* Quote Block */}
            <div className="bg-dark-card border-l-[3px] border-gold p-6 md:p-8 rounded-r-lg" data-id="element-20">
              <p className="font-serif italic text-cream text-[18px] leading-relaxed mb-4" data-id="element-21">
                "Vivir un evento cardiovascular mayor (6 bypass) y no faltó
                explicación profunda. Este ebook traduce evidencia científica a
                lenguaje claro."
              </p>
              <p className="font-sans text-sm text-gray-warm uppercase tracking-wider" data-id="element-22">
                — Roderic Guillen · GoDeskCore
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}